import { useTranslation } from "react-i18next";
import { InstituteFilterSelect } from "@/features/tenantUsers/components/InstituteFilterSelect";
import { useStudentInstitutionOptions } from "../hooks/useStudentLookupOptions";

interface StudentInstituteFilterProps {
  /** Selected institute id, "" for all institutes. */
  value: string;
  onChange: (instituteId: string) => void;
}

/**
 * Searchable institute dropdown shown next to the students search box. Options come from
 * GET api/v1/institutions (shared with the add-student form).
 */
export function StudentInstituteFilter({
  value,
  onChange,
}: StudentInstituteFilterProps) {
  const { t } = useTranslation(["students", "common"]);
  const { data, isLoading, isError } = useStudentInstitutionOptions();

  return (
    <InstituteFilterSelect
      value={value}
      onChange={onChange}
      options={data}
      isLoading={isLoading}
      isError={isError}
      labels={{
        ariaLabel: t("students:filter.institute"),
        all: t("students:filter.allInstitutes"),
        placeholder: t("students:filter.placeholder.institute"),
        loading: t("students:addForm.institute.loading"),
        loadFailed: t("students:addForm.institute.loadFailed"),
        searchPlaceholder: t("common:actions.search"),
        viewAll: t("common:actions.viewAll"),
      }}
    />
  );
}
